import { nodeRedApi } from '../../services/axios';

export default async function getRegistrosEventos() {
  try {
    const { data } = await nodeRedApi.get('/RegistrosEventos');
    return data;
  } catch (error) {
    return [];
  }
}